// extracted by mini-css-extract-plugin
export default {"select":"GenericSelect_select__Gsn7W","popup":"GenericSelect_popup__fEDY-"};